var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{staticClass:"googleMaps",style:('height:'+_vm.height),attrs:{"center":{ lat:_vm.position.lat, lng:_vm.position.lng},"zoom":5}},[_c('GmapMarker',{attrs:{"position":_vm.position,"clickable":true,"draggable":true},on:{"click":function($event){_vm.center=_vm.position}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }